import React from "react";
import { useLang } from "./LanguageProvider";
import { ArrowUpRight } from "lucide-react";

export default function InvestorPitch() {
  const { t, isRtl } = useLang();

  const goContact = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="investor"
      data-testid="investor-section"
      className="relative bg-brand-navy py-24 md:py-40 border-t border-white/5"
    >
      <div className="container mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16 md:mb-24">
          <div className="lg:col-span-5 reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-brand-teal" />
              <span className="text-[11px] uppercase tracking-[0.28em] text-brand-teal font-semibold">
                {t.investor.overline}
              </span>
            </div>
            <h2 className="font-heading text-white text-3xl sm:text-4xl md:text-5xl lg:text-[56px] leading-[1.05] font-medium tracking-tight">
              {t.investor.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 reveal reveal-delay-1">
            <p className={`text-base md:text-lg text-white/65 leading-relaxed ${isRtl ? "text-right" : "text-left"}`}>
              {t.investor.lead}
            </p>
            <button
              onClick={goContact}
              data-testid="investor-cta"
              className={`mt-8 inline-flex items-center gap-2 text-sm font-medium text-white border-b border-brand-teal pb-1 hover:text-brand-teal transition-colors`}
            >
              {t.investor.cta}
              <ArrowUpRight size={16} className={isRtl ? "rotate-90" : ""} />
            </button>
          </div>
        </div>

        {/* Pillars — editorial 4-row stack */}
        <div className="flex flex-col">
          {t.investor.pillars.map((p, i) => (
            <div
              key={i}
              data-testid={`investor-pillar-${i}`}
              className={`reveal reveal-delay-${(i % 4) + 1} group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-t border-white/10 ${
                i === t.investor.pillars.length - 1 ? "border-b" : ""
              }`}
            >
              <div className="md:col-span-2 flex md:flex-col items-baseline md:items-start gap-3">
                <span className="display-num text-brand-teal text-2xl md:text-3xl">
                  0{i + 1}
                </span>
                <span className="text-[10px] uppercase tracking-[0.22em] text-white/45 font-semibold">
                  {p.tag}
                </span>
              </div>
              <div className="md:col-span-5">
                <h3 className="font-heading text-white text-2xl md:text-3xl lg:text-[34px] leading-tight font-medium tracking-tight">
                  {p.title}
                </h3>
              </div>
              <div className={`md:col-span-5 ${isRtl ? "md:text-right" : ""}`}>
                <p className="text-white/65 text-base md:text-lg leading-relaxed">
                  {p.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
